/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('[data-booking-modal]');
    if (!modal) return;

    var openTriggers = document.querySelectorAll('[data-booking-modal-open]');
    var closeTriggers = modal.querySelectorAll('[data-booking-modal-close]');
    var rows = modal.querySelectorAll('[data-calendly-url]');

    function openModal(e) {
      if (e) e.preventDefault();
      modal.setAttribute('data-state', 'open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal(e) {
      if (e) e.preventDefault();
      modal.setAttribute('data-state', 'closed');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openTriggers.forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });

    closeTriggers.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('data-state') === 'open') {
        closeModal();
      }
    });

    rows.forEach(function (row) {
      row.addEventListener('click', function (e) {
        e.preventDefault();
        var url = row.getAttribute('data-calendly-url');

        if (window.Calendly && url) {
          window.Calendly.initPopupWidget({ url: url });
        } else if (url) {
          window.open(url, '_blank');
        }
      });
    });
  });




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
